<div class="pos-content-container">
  @if (content) {
  <div class="campaign-content">
    @for (banner of pricedBanners; track $index) {
    <div class="campaign-banner" [style.backgroundImage]="'url(' + banner.imageUrl + ')'">
      @for (bannerItem of banner.items; track $index) {
      <div>
        @if (bannerItem.coords) {
        <div
          class="campaign-banner-item"
          [style.left]="(bannerItem?.coords?.x || 0) + 'px'"
          [style.top]="(bannerItem?.coords?.y || 0) + 'px'"
        >
          {{ banner.fallbackEnabled ? '' : bannerItem.price }}
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  }
</div>
